// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w9WJ1a1O18aymJ {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  min-width: 28px;
  height: 24px;
  margin-top: var(--ds-space-050, 4px);
  margin-right: var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0) var(--ds-space-075, 5px) var(--ds-space-0, 0) var(--ds-space-100, 7px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-400, 18px);
  /* stylelint-disable-next-line declaration-no-important */
  background-color: var(--ds-background-input, #ffffff) !important;
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-bold, 700);
  cursor: pointer;
}
.w9WJ1a1O18aymJ .FlEniANsPSqYnu {
  font-size: 12px;
  line-height: 1;
  vertical-align: text-bottom;
  pointer-events: none;
}
.w9WJ1a1O18aymJ:hover,
.w9WJ1a1O18aymJ.w7CWSa4fjpZoh6 {
  border: 1px solid var(--ds-border-selected, #0c66e4);
}
.w9WJ1a1O18aymJ.w7CWSa4fjpZoh6 {
  background: var(--ds-background-selected, #e9f2ff);
}
.w9WJ1a1O18aymJ.w7CWSa4fjpZoh6 .FlEniANsPSqYnu {
  color: var(--ds-text-brand, #0c66e4);
}
.w9WJ1a1O18aymJ:hover {
  background-color: var(--ds-surface-raised, #ffffff);
}
.w9WJ1a1O18aymJ .emoji-mart-emoji {
  width: 16px;
  height: 16px;
  margin-right: var(--ds-space-050, 4px);
  font-size: 16px;
  pointer-events: none;
}
.w9WJ1a1O18aymJ.Qags7FewV7uomi {
  border: 1px solid var(--ds-border-disabled, #091e420f);
  background-color: transparent;
  pointer-events: none;
}
.w9WJ1a1O18aymJ.Qags7FewV7uomi .emoji-mart-emoji {
  opacity: 0.7;
}
.w9WJ1a1O18aymJ.Qags7FewV7uomi .FlEniANsPSqYnu {
  opacity: 0.7;
  color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
export var reaction = `w9WJ1a1O18aymJ`;
export var reactionCount = `FlEniANsPSqYnu`;
export var myReaction = `w7CWSa4fjpZoh6`;
export var disabled = `Qags7FewV7uomi`;
export default ___CSS_LOADER_EXPORT___;
